import React, { useState, useEffect } from "react";
import axios from "axios";

import { useSelector, useDispatch } from "react-redux";
import {
  form_load,
  fetch_success4,
  selectPatientelleGrid,
  previous_search,
} from "../../../features/patientelle/patientelleSlice";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Button, Grid, Form, Checkbox } from "semantic-ui-react";
import { server } from "../../../App";
import { columnDefs, defaultColDef } from "./GridParams/GridParams";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { useWindowSize } from "react-use";
import { emptyState_form_load, emptyState_act_form_load } from "../../Api/api";
import SpeedDialComponent from "../../SpeedDial/SpeedDialComponent"

function PatientelleGridBloc(props) {
  const dispatch = useDispatch();
  const PatientelleState = useSelector(selectPatientelleGrid);
  const { register, handleSubmit } = useForm({ mode: "onChange" });

  // ag grid state
  const [, setGridApi] = useState(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [hideColumn, setHideColumn] = useState(true);

  const [startWith, setStartWith] = useState(false);
  const [contain, setContain] = useState(true);

  const { width, height } = useWindowSize();
  const [NewHeightValue, setNewHeightValue] = useState("87vh");

  let navigate = useNavigate();
  let ID = sessionStorage.getItem("ID_Session");
  async function getOneUser() {
    if (ID) {
      await axios
        .get(`${server}users/${ID}`, {
          headers: {
            jwtoken: sessionStorage.token,
          },
        })
        .then((response) => {
          dispatch(fetch_success4(response.data));
          // toast.success("success");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  let searchQuery = {
    cin: PatientelleState?.cinSearch,
    date_naissance: PatientelleState?.date_naissanceSearch,
    nom: PatientelleState?.nomSearch,
    prenom: PatientelleState?.prenomSearch,
    tel: PatientelleState?.telSearch,
  };

  function debounce(cb, delay = 500) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const debounceOnsubmit = debounce((data) => {
    onSubmit(data);
  }, 500);

  // SEARCH FUNCTION
  const onSubmit = async (data) => {
    const { cin, date_naissance, nom, prenom, tel, pathologie_principale } =
      data;
    let mode;
    if (startWith) {
      mode = "startWith";
    } else if (contain) {
      mode = "contain";
    }
    // alphanumerique with space
    const cinRegex = /^[a-zA-Z0-9\s]*$/;
    const telRegex = /^[0-9\s]*$/;
    // alpha with space
    const nomRegex = /^[a-zA-Z\s-'",./]*$/;

    let url;

    if (
      telRegex.test(tel) &&
      tel.length > 2 &&
      cin.length === 0 &&
      date_naissance?.length === 0 &&
      prenom.length === 0 &&
      nom.length === 0
    ) {
      url = `${server}users/SearchByTel/${tel}/${mode}`;
    }

    if (
      cinRegex.test(cin) &&
      // cin.length > 2 &&
      cin.length > 0 &&
      date_naissance?.length === 0 &&
      prenom.length === 0 &&
      nom.length === 0 &&
      tel.length === 0
    ) {
      url = `${server}users/SearchByCin/${cin}/${mode}`;
    }
    if (
      nomRegex.test(pathologie_principale) &&
      // cin.length > 2 &&
      pathologie_principale?.length > 0 &&
      date_naissance?.length === 0 &&
      prenom.length === 0 &&
      nom.length === 0 &&
      tel.length === 0
    ) {
      url = `${server}users/SearchByPathologie_principale/${pathologie_principale}/${mode}`;
    }

    if (
      nomRegex.test(nom) &&
      // nom.length > 2 &&
      nom.length > 0 &&
      nomRegex.test(prenom) &&
      prenom.length > 0 &&
      // prenom.length > 2 &&
      date_naissance?.length > 9 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByNomPrenomDate/${nom}/${prenom}/${date_naissance}/${mode}`;
    }
    if (
      nomRegex.test(nom) &&
      // nom.length > 2 &&
      nom.length > 0 &&
      nomRegex.test(prenom) &&
      // prenom.length > 2 &&
      prenom.length > 0 &&
      date_naissance?.length === 0 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByNomPrenom/${nom}/${prenom}/${mode}`;
    }

    if (
      nomRegex.test(nom) &&
      // nom.length > 2 &&
      nom.length > 0 &&
      date_naissance?.length > 9 &&
      // prenom.length > 2 &&
      prenom.length === 0 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByNomDate/${nom}/${date_naissance}/${mode}`;
    }

    if (
      nomRegex.test(prenom) &&
      // prenom.length > 2 &&
      prenom.length > 0 &&
      date_naissance?.length > 9 &&
      // nom.length > 2 &&
      nom.length === 0 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByPrenomDate/${prenom}/${date_naissance}/${mode}`;
    }

    if (
      nomRegex.test(prenom) &&
      prenom.length > 0 &&
      // prenom.length > 2 &&
      date_naissance?.length === 0 &&
      nom.length === 0 &&
      // nom.length > 2 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByPrenom/${prenom}/${mode}`;
    }

    if (
      nomRegex.test(nom) &&
      // nom.length > 2 &&
      nom.length > 0 &&
      date_naissance?.length === 0 &&
      prenom.length === 0 &&
      tel.length === 0 &&
      cin.length === 0 &&
      nom !== ""
    ) {
      url = `${server}users/SearchByNom/${nom}/${mode}`;
    }

    if (
      date_naissance?.length > 9 &&
      nom.length === 0 &&
      prenom.length === 0 &&
      tel.length === 0 &&
      cin.length === 0
    ) {
      url = `${server}users/SearchByDate/${date_naissance}/${mode}`;
    }
    await axios
      .get(url, {
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
      .then((response) => {
        dispatch(fetch_success4(response.data));
        dispatch(previous_search(data));
        // toast.success("success");
      })
      .catch((err) => {
        console.log(err);
        // toast.error("error");
      });
  };

  useEffect(() => {
    getOneUser();
    onSubmit(searchQuery);
    // let timer1 = setTimeout(() => showColumn(), 10000);
    // return () => {
    //   clearTimeout(timer1);
    // };
    // eslint-disable-next-line
  }, []);

  // setTimeout(() => showColumn(), 10000);

  const onGridReady = (params) => {
    setGridColumnApi(params.columnApi);
    setGridApi(params.api);
    // gridColumnApi.getAllColumns(params.columnApi)
  };

  const showColumn = () => {
    gridColumnApi.setColumnsVisible(
      ["commentaire_sur_patient", "date_de_modification", "date_creation"],
      hideColumn
    );

    setHideColumn(!hideColumn);
    // to fit the size of column FIX COLUMN BUG
    // gridApi.sizeColumnsToFit();
  };

  const onSelectionChanged = (e) => {
    if (e.api.getSelectedRows()[0] === undefined) {
      dispatch(form_load(emptyState_act_form_load));
      console.log(e.api.getSelectedRows()[0]);
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      dispatch(form_load(clientArray));
    }
  };

  const onRowDoubleClicked = (e) => {
    e.defaultPrevented = true;
    if (e.api.getSelectedRows()[0] === undefined) {
      dispatch(form_load(emptyState_form_load));
    } else {
      let clientArray = e.api.getSelectedRows()[0];

      axios
        .get(`${server}users/SearchUserByID/${clientArray.idpatient}`, {
          headers: {
            jwtoken: sessionStorage.token,
          },
        })
        .then((response) => {
          dispatch(form_load(response.data[0]));
          navigate("/Consultation");
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  function name(height, width) {
    if (height === 702 && width === 1366) {
      setNewHeightValue("82vh");
    } else if (height === 702 && width === 1360) {
      setNewHeightValue("82vh");
    } else {
      setNewHeightValue("87.5vh");
    }
  }
  useEffect(() => {
    name(height, width);
  }, [height, width]);

  function switchSearchcontain(contain) {
    setContain((prev) => !prev);
    if (contain) {
      setStartWith(true);
    } else {
      setStartWith(false);
    }
  }
  function switchSearchstartWith(startWith) {
    setStartWith((prev) => !prev);
    if (startWith) {
      setContain(true);
    } else {
      setContain(false);
    }
  }

  let displayLayout = null;

  if (width <= 900) {
    displayLayout = (
      <Grid.Row className="NonPaddingBotom">
        <Grid.Column>
          <Form onChange={handleSubmit(debounceOnsubmit)} className="fixWidth">
            {/* <Form.Group widths="equal" className="fixForm"> */}
            <div className="field">
              <label>Nom</label>
              <div className="ui input">
                <input
                  autoFocus
                  autoComplete="off"
                  name="nom"
                  maxLength={40}
                  type="text"
                  {...register("nom")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Prenom</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="prenom"
                  maxLength={40}
                  type="text"
                  {...register("prenom")}
                />
              </div>
            </div>

            <div className=" field">
              <label>CIN</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="cin"
                  maxLength={20}
                  type="text"
                  {...register("cin")}
                />
              </div>
            </div>
            {/* <Button onClick={showColumn} className="littleMarginBottom">
              {hideColumn === true ? "Mode Avancé" : "Mode Basic"}
            </Button> */}

            {/* <Link to="/PriseEnCharge">
              <Button floated="right" color="blue">
                retour
              </Button>
            </Link> */}
            {/* </Form.Group> */}
          </Form>
        </Grid.Column>
        <Grid.Column>
          <Form onChange={handleSubmit(onSubmit)} className="fixWidth">
            {/* <Form.Group widths="equal" className="fixForm"> */}
            <div className=" field">
              <label>Date de naissance</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  type="date"
                  name="date_naissance"
                  min="1900-01-01"
                  max="3018-12-31"
                  {...register("date_naissance")}
                ></input>
              </div>
            </div>
            <div className=" field">
              <label>Pathologie principale</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="pathologie_principale"
                  maxLength={200}
                  type="text"
                  {...register("pathologie_principale")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Tel</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="tel"
                  maxLength={10}
                  type="text"
                  {...register("tel")}
                />
              </div>
            </div>
            {/* <Form.Group grouped> */}
            {width <= 767 ? null : (
              <div className=" field">
                <Checkbox
                  // width={8}
                  // defaultValue={}
                  // floated="right"
                  className="checkboxFloatedLeftSearch"
                  checked={contain ? true : false}
                  toggle
                  label="Contient expression"
                  // onClick={() => setContain((prev) => !prev)}
                  onClick={() => switchSearchcontain(contain)}
                // className="ToggleCkeckboxclass"
                />
                <br />
                <br />

                <Checkbox
                  className="checkboxFloatedLeftSearch2"
                  // width={8}
                  // defaultValue={}
                  // floated="left"
                  checked={startWith ? true : false}
                  toggle
                  label="Commence par expr"
                  // onClick={() => setStartWith((prev) => !prev)}
                  onClick={() => switchSearchstartWith(startWith)}
                // className="ToggleCkeckboxclass"
                />
                {/* </Form.Group> */}
              </div>
            )}
            {/* {width <= 767 ? (
              PatientelleState.nom === undefined ? (
                <Link to="/PatientelleGridPriseEnCharge">
                  <Button className="IconFixDopdown" color="green">
                    Ajouter
                  </Button>
                </Link>
              ) : PatientelleState.nom === "" ? (
                <Link to="/PatientelleGridPriseEnCharge">
                  <Button className="IconFixDopdown" color="green">
                    Ajouter
                  </Button>
                </Link>
              ) : (
                <Link to="/CreatePriseEnChagre">
                  <Button className="IconFixDopdown" color="green">
                    Ajouter
                  </Button>
                </Link>
              )
            ) : null} */}
            {/* </Form.Group> */}
          </Form>
        </Grid.Column>
      </Grid.Row>
    );
  } else if (width < 1280) {
    displayLayout = (
      <Grid.Row className="NonPaddingBotom">
        <Grid.Column>
          <Form onChange={handleSubmit(debounceOnsubmit)} className="fixWidth">
            {/* <Form.Group widths="equal" className="fixForm"> */}
            <div className="field">
              <label>Nom</label>
              <div className="ui input">
                <input
                  autoFocus
                  autoComplete="off"
                  name="nom"
                  maxLength={40}
                  type="text"
                  {...register("nom")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Prenom</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="prenom"
                  maxLength={40}
                  type="text"
                  {...register("prenom")}
                />
              </div>
            </div>


            {/* <Button onClick={showColumn} className="littleMarginBottom">
              {hideColumn === true ? "Mode Avancé" : "Mode Basic"}
            </Button> */}

            {/* <Link to="/PriseEnCharge">
              <Button floated="right" color="blue">
                retour
              </Button>
            </Link> */}
            {/* </Form.Group> */}
          </Form>
        </Grid.Column>
        <Grid.Column>
          <Form onChange={handleSubmit(onSubmit)} className="fixWidth">
            {/* <Form.Group widths="equal" className="fixForm"> */}
            <div className=" field">
              <label>Date de naissance</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  type="date"
                  name="date_naissance"
                  min="1900-01-01"
                  max="3018-12-31"
                  {...register("date_naissance")}
                ></input>
              </div>
            </div>
            <div className=" field">
              <label>Pathologie principale</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="pathologie_principale"
                  maxLength={200}
                  type="text"
                  {...register("pathologie_principale")}
                />
              </div>
            </div>


            {/* <Form.Group grouped> */}


            {/* </Form.Group> */}
          </Form>
        </Grid.Column>
        <Grid.Column>
          <Form onChange={handleSubmit(onSubmit)} className="fixWidth">
            <div className=" field">
              <label>CIN</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="cin"
                  maxLength={20}
                  type="text"
                  {...register("cin")}
                />
              </div>
            </div>



            <div className=" field">
              <Checkbox
                // width={8}
                // defaultValue={}
                // floated="right"
                className="checkboxFloatedLeftSearch"
                checked={contain ? true : false}
                toggle
                label="Contient expression"
                // onClick={() => setContain((prev) => !prev)}
                onClick={() => switchSearchcontain(contain)}
              // className="ToggleCkeckboxclass"
              />
              <br />
              <br />

              <Checkbox
                className="checkboxFloatedLeftSearch2"
                // width={8}
                // defaultValue={}
                // floated="left"
                checked={startWith ? true : false}
                toggle
                label="Commence par expr"
                // onClick={() => setStartWith((prev) => !prev)}
                onClick={() => switchSearchstartWith(startWith)}
              // className="ToggleCkeckboxclass"
              />
              {/* </Form.Group> */}
            </div>

          </Form>
        </Grid.Column>
        <Grid.Column>
          <Form onChange={handleSubmit(onSubmit)} className="fixWidth">
            <div className=" field">
              <label>Tel</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="tel"
                  maxLength={10}
                  type="text"
                  {...register("tel")}
                />
              </div>
            </div>
            {/* {PatientelleState.nom === undefined ? (
              <Link to="/PatientelleGridPriseEnCharge">
                <Button className="IconFixDopdown" color="green">
                  Ajouter
                </Button>
              </Link>
            ) : PatientelleState.nom === "" ? (
              <Link to="/PatientelleGridPriseEnCharge">
                <Button className="IconFixDopdown" color="green">
                  Ajouter
                </Button>
              </Link>
            ) : (
              <Link to="/CreatePriseEnChagre">
                <Button className="IconFixDopdown" color="green">
                  Ajouter
                </Button>
              </Link>
            )} */}

            {/* <Button onClick={showColumn} className="littleMarginBottom2">
              {hideColumn === true ? "Affichage Avancé" : "Afffichage Basic"}
            </Button> */}
            {/* <Link to="/PriseEnCharge">
              <Button floated="right" color="blue">
                retour
              </Button>
            </Link> */}
          </Form>
        </Grid.Column>
      </Grid.Row>
    );
  }

  else {
    displayLayout = (
      <Grid.Row className="paddingZero">
        <Form onChange={handleSubmit(debounceOnsubmit)} className="fixWidth">
          <Form.Group widths="equal" className="fixForm">
            <div className="field">
              <label>Nom</label>
              <div className="ui input">
                <input
                  autoFocus
                  autoComplete="off"
                  name="nom"
                  maxLength={40}
                  type="text"
                  {...register("nom")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Prenom</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="prenom"
                  maxLength={40}
                  type="text"
                  {...register("prenom")}
                />
              </div>
            </div>

            <div className=" field">
              <label>CIN</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="cin"
                  maxLength={20}
                  type="text"
                  {...register("cin")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Date de naissance</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  type="date"
                  name="date_naissance"
                  min="1900-01-01"
                  max="3018-12-31"
                  {...register("date_naissance")}
                ></input>
              </div>
            </div>
            <div className=" field">
              <label>Pathologie principale</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="pathologie_principale"
                  maxLength={200}
                  type="text"
                  {...register("pathologie_principale")}
                />
              </div>
            </div>

            <div className=" field">
              <label>Tel</label>
              <div className="ui input">
                <input
                  autoComplete="off"
                  name="tel"
                  maxLength={10}
                  type="text"
                  {...register("tel")}
                />
              </div>
            </div>
            {/* <Form.Group grouped> */}
            <div className=" field">
              <br />
              <Checkbox
                // width={8}
                // defaultValue={}
                // floated="right"
                className="checkboxFloatedLeftSearch"
                checked={contain ? true : false}
                toggle
                label="Contient expression"
                // onClick={() => setContain((prev) => !prev)}
                onClick={() => switchSearchcontain(contain)}
              // className="ToggleCkeckboxclass"
              />
              {/* <br />
              <br /> */}

              <Checkbox
                className="checkboxFloatedLeftSearch2"
                // width={8}
                // defaultValue={}
                // floated="left"
                checked={startWith ? true : false}
                toggle
                label="Commence par expr"
                // onClick={() => setStartWith((prev) => !prev)}
                onClick={() => switchSearchstartWith(startWith)}
              // className="ToggleCkeckboxclass"
              />
              {/* </Form.Group> */}
            </div>
          </Form.Group>
        </Form>
      </Grid.Row>
    );
  }

  return (
    <>
      <h1 className="titrePatient">Ajouter au bloc</h1>
      <Grid columns="equal" centered className="fixWidth">
        {/* <Grid.Row> */}
        {/* <Button.Group vertical={width <= 767 ? true : false}> */}
        {displayLayout}

        <Grid.Row className="NonPaddingBotom">
          {PatientelleState.nom === undefined ? (
            <Link to="/PatientelleGridBloc">
              <Button className="IconFixDopdown" color="green">
                Ajouter au bloc
              </Button>
            </Link>
          ) : PatientelleState.nom === "" ? (
            <Link to="/PatientelleGridBloc">
              <Button className="IconFixDopdown" color="green">
                Ajouter au bloc
              </Button>
            </Link>
          ) : (
            <Link to="/CreateBloc">
              <Button className="IconFixDopdown" color="green">
                Ajouter au bloc
              </Button>
            </Link>
          )}

          {/* <Button onClick={showColumn} className="littleMarginBottom2">
              {hideColumn === true ? "Affichage Avancé" : "Afffichage Basic"}
            </Button> */}
          <Link to="/bloc_Main">
            <Button floated="right" color="blue">
              retour
            </Button>
          </Link>
        </Grid.Row>


        {/* </Button.Group> */}
      </Grid>
      <div
        id="myGrid"
        className="ag-theme-alpine"
        style={{
          height: NewHeightValue,
          width: "100%",
        }}
      >
        <AgGridReact
          // reactUi={true}
          rowData={PatientelleState.rowData4}
          animateRows={true}
          sortingOrder={["desc", "asc", null]}
          onGridReady={onGridReady}
          tooltipShowDelay={1500}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          rowSelection={"single"}
          onSelectionChanged={onSelectionChanged}
          onRowDoubleClicked={onRowDoubleClicked}
        ></AgGridReact>
        <br></br>
        <br></br>
        <br></br>
        <br></br>
      </div>
      <SpeedDialComponent showColumn={showColumn} hideColumn={hideColumn} />
    </>
  );
}

export default PatientelleGridBloc;
